import { useCallback, useEffect, useState } from "react";
import {
  acknowledgeDataReconciliationFindings,
  getDataReconciliationAlertSummary,
} from "../data/adminClient.js";
import { log } from "../utils/logger.js";

const REFRESH_INTERVAL_MS = 60_000;

export function useDataReconciliationSummary(currentRole) {
  const [summary, setSummary] = useState(null);
  const isAdmin = currentRole === "admin";

  const refresh = useCallback(async () => {
    if (!isAdmin) return null;
    try {
      const next = await getDataReconciliationAlertSummary();
      setSummary(next);
      return next;
    } catch (err) {
      log.warn("Reconciliation alert summary fetch failed", { err: String(err) });
      return null;
    }
  }, [isAdmin]);

  useEffect(() => {
    setSummary(null);
    if (!isAdmin) return undefined;

    void refresh();
    const intervalId = window.setInterval(() => { void refresh(); }, REFRESH_INTERVAL_MS);
    const onFocus = () => { void refresh(); };
    window.addEventListener("focus", onFocus);
    return () => {
      window.clearInterval(intervalId);
      window.removeEventListener("focus", onFocus);
    };
  }, [isAdmin, refresh]);

  const acknowledge = useCallback(async (findingVersion) => {
    if (!isAdmin) return null;
    const next = await acknowledgeDataReconciliationFindings(findingVersion);
    setSummary(next);
    return next;
  }, [isAdmin]);

  return {
    summary: isAdmin ? summary : null,
    refresh,
    acknowledge,
  };
}